import React from 'react';
import { accessibilityStringifyDates } from '../service/service'

const AccessibilityDate = ({ children, ...params }) => {

    const description = accessibilityStringifyDates(params.eventFromDate);

    return React.Children.map(children, (child) => {
        if (typeof child === 'string') {
            return <span aria-label={description}>{child}</span>;
        } else if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                'aria-label': description,
            });
        }
        return child;
    });
}

export default AccessibilityDate;